<template>
    <div class="w-auto pl-0 pr-0 xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
        <div class="flex w-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5">
            <div class="flex flex-column w-full surface-0 pt-4 pl-3 pr-3 xl:p-6 lg:p-5 md:p-4 xl:border-round-xl lg:border-round-xl">
                <span class="flex text-900 font-medium mb-4 xl:mb-6 text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                    Все файлы
                </span>
                <div class="w-auto pb-3">
                    <DataTable v-if='files' :value="files" v-model:filters="filters" responsiveLayout="scroll" @filter="onFilter($event)" filterDisplay="menu" 
                        lazy paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalRecords"
                        @page="onPage($event)" @sort="onSort($event)" :loading="loading" :globalFilterFields="['id', 'transfer_id', 'user_id']">
                        
                        <Column field="id" header="ID" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                            </template>
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row" @click="copy(data.id)">
                                    <span class="flex">{{get_short_id(data.id)}}</span>
                                    <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                </span>
                            </template>
                        </Column>

                        <Column field="name" header="name" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row white-space-nowrap" @click="copy(data.name)">
                                    <span class="flex">{{getShortName(data.name)}}</span>
                                    <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                </span>
                            </template>
                        </Column>

                        <Column field="file" header="file" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-sm flex flex-row">
                                    <Button icon="pi pi-download" @click="saveFile(data.path, data.name)" class="mr-2"/>
                                    <Button icon="pi pi-eye" @click="openPopup(data.path)" />
                                </span>
                            </template>
                        </Column>

                        <Column field="from" header="from" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row">
                                    <span v-if="data.from" class="flex">{{data.from}}</span>
                                </span>
                            </template>
                        </Column>

                        <Column field="transfer_id" header="transfer_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                            </template>
                            <template #body="{ data }">
                                <div class="flex flex-row" v-if="data.transfer_id">
                                    <span class="flex text-xs flex flex-row mr-2" @click="copy(data.transfer_id)">
                                        <span class="flex">{{get_short_id(data.transfer_id)}}</span>
                                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                    </span>
                                    <span class="flex text-xs flex flex-row" @click="goToTransfer(data.transfer_id)">
                                        <span class="flex pi pi-external-link ml-2 text-500 text-xs cursor-pointer"></span>
                                    </span>
                                </div>
                            </template>
                        </Column>

                        <Column field="user_id" header="user_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                            </template>
                            <template #body="{ data }">
                                <div class="flex flex-row" v-if="data.user_id">
                                    <span class="flex text-xs flex flex-row mr-2" @click="copy(data.user_id)">
                                        <span class="flex">{{get_short_id(data.user_id)}}</span>
                                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                    </span>
                                    <span class="flex text-xs flex flex-row" @click="goToUser(data.user_id)">
                                        <span class="flex pi pi-external-link ml-2 text-500 text-xs cursor-pointer"></span>
                                    </span>
                                </div>
                            </template>
                        </Column>

                        <Column field="doc_type" header="doc_type" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row white-space-nowrap">
                                    <span class="flex">{{data.doc_type}}</span>
                                </span>
                            </template>
                        </Column>

                        <Column field="mimetype" header="mimetype" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row white-space-nowrap">
                                    <span class="flex">{{data.mimetype}}</span>
                                </span>
                            </template>
                        </Column>

                        <Column field="size" header="size" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row white-space-nowrap">
                                    <span class="flex">{{formatSize(data.size)}}</span>
                                </span>
                            </template>
                        </Column>

                        <Column field="path" header="path" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row white-space-nowrap" @click="copy(data.path)">
                                    <span class="flex">{{getShortName(data.path)}}</span>
                                    <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                </span>
                            </template>
                        </Column>

                        <Column field="date" header="date" filterMatchMode="startsWith" >
                            <template #body="{ data }">
                                <span class="text-xs flex flex-row white-space-nowrap">
                                    <span class="flex">{{formatDate(data.date)}}</span>
                                </span>
                            </template>
                        </Column>
                        <template #footer>Всего {{ totalRecords }} записей. </template>
                    </DataTable>
                    <Skeleton height="2rem" v-else />
                </div>

                <Dialog header="file" v-model:visible="popup" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
                    <img :src="file_url" class="w-full">
                </Dialog>

            </div>
        </div>
    </div>

    

</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import axios from 'axios';

export default {
    data() {
        return {
            files: null,
            loading: false,
            lazyParams: {},
            totalRecords: 50,
            popup: false,
            detail_data: null,

            file_url: null,
            filters: {
                id: {value: '', matchMode: 'contains'},
                transfer_id: {value: '', matchMode: 'contains'},
                user_id: {value: '', matchMode: 'contains'},
            }
        }
    },
    methods: {
        async getFile(path) {
            if(!path) return
            const file = await this.connect.get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                this.file_url = url
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        async saveFile(path, name) {
            if(!path) return
            if(!name) return
            const file = await this.connect.get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        onPage(event) {
            this.lazyParams = event
            this.loadLazyData()
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.loadLazyData();
        },
        async loadLazyData() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
            const files = await this.connect.files_list(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters).then(res => res)
            if (files.result && files.data.length > 0) {
                this.files = files.data
                this.totalRecords = files.total
            }
            this.loading = false
        },
        get_format_amount(value, currency) {
            if(!value) return 0
            return this.helper.format_amount(value, currency)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        openPopup(path) {
            if(!path) return
            this.popup = true
            this.getFile(path)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        formatSize(bytes) {
            const k = 1024;
            const dm = 3;
            const sizes = this.$primevue.config.locale.fileSizeTypes;

            if (bytes === 0) {
                return `0 ${sizes[0]}`;
            }

            const i = Math.floor(Math.log(bytes) / Math.log(k));
            const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

            return `${formattedSize} ${sizes[i]}`;
        },
        goToTransfer(id){
            const routeData = this.$router.resolve({path: '/admin/transfer/' + id});
            window.open(routeData.href, '_blank');
        },
        goToUser(id){
            const routeData = this.$router.resolve({path: '/admin/user/' + id});
            window.open(routeData.href, '_blank');
        },
        getShortName(name){
            if(name.length > 20){
                return name.slice(0,5) + '...' + name.slice(-8)
            } else {
                return name
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.lazyParams = {
            first: 0,
            rows: 50,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        }

        // получим параметры из url
        const query = (this.$route.query) ? this.$route.query : {}
        if(query && query.user_id) this.filters.user_id = {value: query.user_id, matchMode: 'contains'}
        if(query && query.id) this.filters.id = {value: query.id, matchMode: 'contains'}

        this.loadLazyData()
    },
}
</script>